import { Stack, Typography } from '@mui/material';

import {
  type FeedbackRating,
  FeedbackRatingButtons,
} from '@/components/form/baseInputs/Button/FeedbackRatingButtons';
import { MemoAiRating } from '@/types/schema';

interface AiMemoRatingButtonsProps {
  rating: MemoAiRating | null | undefined;
  disabled: boolean;
  onRateMemo: (rating: MemoAiRating) => void;
}

export function AiMemoRatingButtons({
  rating,
  disabled,
  onRateMemo,
}: AiMemoRatingButtonsProps) {
  let feedbackRating: FeedbackRating | null = null;
  if (rating === MemoAiRating.Good) {
    feedbackRating = 'good';
  } else if (rating === MemoAiRating.Bad) {
    feedbackRating = 'bad';
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="body-xs">Rate AI memo</Typography>
      <FeedbackRatingButtons
        rating={feedbackRating}
        disabled={disabled}
        likeAriaLabel="I like this memo"
        dislikeAriaLabel="I dislike this memo"
        onRate={(newRating) => {
          onRateMemo(
            newRating === 'good' ? MemoAiRating.Good : MemoAiRating.Bad
          );
        }}
      />
    </Stack>
  );
}
